import { gql } from '@/__generated__';

const HARD_DELETE_USER = gql(`#graphql
  mutation HardDeleteUser($input: HardDeleteUserInput!) {
    hardDeleteUser(input: $input) {
      userId
    }
  }
`);

export default HARD_DELETE_USER;
